export default "__VITE_PUBLIC_ASSET__829d58bd__"